import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { commonAbout } from 'app/containers/Maps/LayerAbout/CommonAbout';
import FormGenerator from 'app/containers/Designer/Form/components/FormGenerator';
import { isDefined } from 'app/utils/utils';
import { updateMapLayer } from 'store/actions/maps/situationalAwarenessActions';
import { LAYERS, LAYERS_NAMES, __getMapLayers } from 'app/utils/maps/layer/layerUtils';
import { additionalFields } from 'app/containers/Maps/AddLayerModal/AdditionalFields';

const Container = styled.div`
    max-width: 960px;
    margin: auto;
`;

class XYZLayerAbout extends PureComponent {
    static propTypes = {
        id: PropTypes.string.isRequired,
        map: PropTypes.object.isRequired,
        mapId: PropTypes.string.isRequired,
        layer: PropTypes.object.isRequired,
        details: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const layerForm = { ...(props.data || props.details || {}) };
        this.state = {
            layerForm,
            initialForm: layerForm,
            formChanged: false,
        };
    }

    formRef = React.createRef();

    componentDidMount() {
        this.props.setActions(this.onFormSubmit);
    }

    componentDidUpdate() {
        const { setToDefault, setActions } = this.props;
        if (setToDefault) {
            this.setState({ layerForm: this.state.initialForm, formChanged: false });
            setActions && setActions(null);
        }
    }

    @bind
    buildFormDefinition(data) {
        const { id, name } = this.props?.details || {};
        return [
            ...commonAbout({ ...data, title: this.props.title, id, name }),
            {
                field: 'panel',
                type: 'panel',
                properties: {
                    header: 'XYZ Layer Info',
                    expanded: false,
                },
                children: additionalFields(LAYERS_NAMES.xyz),
            },
        ].filter(Boolean);
    }

    @bind
    handleChange(data) {
        const layerForm = { ...data };

        this.setState({ layerForm }, async () => {
            const { formChanged } = this.state;
            const hasChanged = !this.isFormEqualToInitial(layerForm);
            if (hasChanged !== formChanged) {
                this.setState({ formChanged: hasChanged });
                await this.props.setStatus(hasChanged);
                this.props.setActions(hasChanged ? this.onFormSubmit : null);
            }
        });
    }

    @bind
    isFormEqualToInitial(currentForm) {
        const { initialForm } = this.state;

        const keysToCompare = ['description', 'url', 'apiKey', 'minZoom', 'maxZoom', 'projection'];

        for (const key of keysToCompare) {
            if (currentForm[key] !== initialForm[key]) {
                return false;
            }
        }
        return true;
    }

    @bind
    async handleProjectionChange(data) {
        const { details, map } = this.props;
        if (details?.projection !== data?.projection) {
            await map.removeLayerFromAllLayersById(data?.name);
        }
    }

    @bind
    onFormSubmit() {
        this.formRef.current.isValidForm().then(async ({ data, errors }) => {
            if (!errors) {
                const { id, details, allMapLayers, map } = this.props;
                const { description, url, apiKey, minZoom, maxZoom, projection } = data;
                const { type } = details || '';
                const foundLayer = allMapLayers.find((layer) => layer.id === id);
                const updatedLayerData = {
                    ...this.state.layerForm,
                    id,
                    name: foundLayer?.name,
                    type: LAYERS[type],
                    description,
                    url,
                    apiKey,
                    minZoom,
                    maxZoom,
                    projection,
                    active: true,
                    visible: isDefined(foundLayer?.visible) ? foundLayer?.visible : true,
                    opacity: foundLayer?.opacity || 100,
                };

                this.props.updateMapLayer(updatedLayerData);
                this.setState({
                    initialForm: this.state.layerForm,
                    formChanged: false,
                });
                this.props.setStatus(false);
                this.props.setActions(null);

                map.addXYZPreviewLayer({ layerId: id, url, apiKey, projection });
            }
        });
    }

    render() {
        const { layerForm } = this.state;

        return (
            <Container>
                <FormGenerator
                    data={layerForm}
                    onChange={this.handleChange}
                    components={this.buildFormDefinition(layerForm)}
                    ref={this.formRef}
                />
            </Container>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        allMapLayers: __getMapLayers(state.maps.situationalAwareness.map.data),
    }),
    {
        updateMapLayer,
    }
)(XYZLayerAbout);
